/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ app: NonNullable<unknown> }} Mcp_Connect_Approved_LedeInputs */

const en_mcp_connect_approved_lede = /** @type {(inputs: Mcp_Connect_Approved_LedeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Return to ${i?.app} to finish connecting. We’ll take you there automatically.`)
};

const es_mcp_connect_approved_lede = /** @type {(inputs: Mcp_Connect_Approved_LedeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vuelve a ${i?.app} para terminar de conectar. Te llevaremos automáticamente.`)
};

/**
* | output |
* | --- |
* | "Return to {app} to finish connecting. We’ll take you there automatically." |
*
* @param {Mcp_Connect_Approved_LedeInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_approved_lede = /** @type {((inputs: Mcp_Connect_Approved_LedeInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Approved_LedeInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_approved_lede(inputs)
	return en_mcp_connect_approved_lede(inputs)
});